import Box from '@mui/material/Box';
import { ReactNode } from 'react';

import { SidebarContainer } from './SidebarContainer';

type Props = {
  isOpen: boolean;
  children: ReactNode;
};

export const Sidebar = ({ isOpen, children }: Props) => {
  return (
    <Box
      sx={(theme) => ({
        borderLeft: `1px solid ${theme.palette.border.main}`,
        maxWidth: 420,
        overflow: 'hidden',
        transform: isOpen ? 'translateX(0)' : 'translateX(420px)',
        transition: '300ms',
        [theme.breakpoints.down('md')]: {
          height: '100%',
          left: 0,
          maxWidth: 'unset',
          position: 'absolute',
          top: 0,
          transform: isOpen ? 'translateX(0)' : 'translateX(900px)',
          width: '100%',
        },
      })}
    >
      {children}
    </Box>
  );
};

Sidebar.Container = SidebarContainer;
